// extracted by mini-css-extract-plugin
export var component = "gender-module--component--24trk";
export var content = "gender-module--content--3r7Vz";
export var title = "gender-module--title--3iVe9";
export var hr = "gender-module--hr--2gYhh";
export var pie = "gender-module--pie--2Lq2Y";
export var body = "gender-module--body--3FFyZ";
export var text = "gender-module--text--2EXh2";